
import record from "./record";
import {
  Replayer,
  type playerConfig,
  type PlayerMachineState,
  type SpeedMachineState,
} from "./replay";
import canvasMutation from "./replay/canvas";
import * as utils from "./utils";
import { _mirror } from "./utils";

export {
  EventType,
  IncrementalSource,
  MouseInteractions,
  ReplayerEvents,
  type eventWithTime
} from "@sailfish-rrweb/types";

// exports style.css from replay
import "./replay/styles/style.css";

export type { recordOptions, ReplayPlugin } from "./types";

const { addCustomEvent } = record;
const { addSailfishEvent } = record;
const { freezePage } = record;
const { takeFullSnapshot } = record;

export * from "./record";
export * from "./utils";

export {
  addCustomEvent,
  addSailfishEvent,
  canvasMutation,
  freezePage,
  _mirror as mirror,
  record,
  Replayer,
  takeFullSnapshot,
  utils,
  type playerConfig,
  type PlayerMachineState,
  type SpeedMachineState,
};
